<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("organization", 1) }}
      </div>
      <router-link class="btn-blue" to="organizations"
        >{{ $tc("organization", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <section class="mb-2 w-100 px-3 distributor-section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-border section-border"
            v-b-toggle.orgainizationDetails
          >
            <span>
              {{ $t("add organization details") }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="orgainizationDetails"
            class="mt-2"
            v-model="sectionCollapse.orgainizationDetails"
          >
            <div class="row">
              <div
                v-for="(item, index) in Organizations"
                :key="index"
                v-if="item.fieldname !== 'org_id'"
                :class="
                  item.type === 'color'
                    ? 'col-lg-3 col-xl-1 align-self-center mb-4 px-0'
                    : 'col-lg-6 col-xl-3 align-self-center mb-4'
                "
              >
                <div
                  v-if="
                    item.type !== 'radio' &&
                    item.type !== 'dropdown' &&
                    item.type !== 'file' &&
                    item.type !== 'color'
                  "
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material d-flex align-items-center">
                      <div
                        v-if="item.fieldname === 'org_contact_no'"
                        class="col-4 pl-0"
                      >
                        <!--  -->
                        <b-dropdown
                          :text="
                            SelectedCountryCode ? SelectedCountryCode : 'Code'
                          "
                          variant="dropdown-curve"
                          class="w-100 text-center mr-3"
                          placeholder="code"
                          name="countrycode"
                          id="countrycode"
                        >
                          <div class="px-2 pb-2">
                            <input
                              autofocus
                              type="search"
                              placeholder="Search Code"
                              class="form-control form-control-sm"
                              v-on:keyup="onSearchCode($event.target.value)"
                              v-on:keydown="onSearchCode($event.target.value)"
                              v-on:search="onSearchCode($event.target.value)"
                              v-model="searchCode"
                            />
                          </div>
                          <b-dropdown-item
                            href="#"
                            v-for="(countrycode, countryIndex) in countryList"
                            :key="countryIndex"
                            v-on:click="
                              onSelectHandler('countrycode', countrycode)
                            "
                            v-if="countrycode.country_mob_code != null"
                            >{{ countrycode.country_mob_code }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </div>
                      <div class="position-relative w-100">
                        <input
                          v-if="item.type !== 'date'"
                          :disabled="
                            item.fieldname === 'cine_screens'
                              ? isDisabled
                              : false
                          "
                          @focus="onFocusHandler"
                          :type="item.type"
                          :name="item.fieldname"
                          :id="item.fieldname"
                          v-validate="item.validation"
                          v-model="item.fieldvalue"
                          placeholder="."
                        />

                        <input
                          :style="
                            item.fieldname === 'cine_screens'
                              ? 'text-align:right;'
                              : ''
                          "
                          v-if="item.type === 'date'"
                          :disabled="
                            item.fieldname === 'cine_screens'
                              ? isDisabled
                              : item.fieldname === 'org_setup_date'
                              ? true
                              : item.fieldname === 'org_launch_date'
                              ? true
                              : false
                          "
                          @focus="onFocusHandler"
                          :type="item.type"
                          :format="item.format"
                          :name="item.fieldname"
                          :id="item.fieldname"
                          v-validate="item.validation"
                          v-model="item.fieldvalue"
                          placeholder="."
                        />
                        <label>{{ $tc(item.label, 1) }}</label>
                      </div>
                    </div>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has(item.fieldname)">{{
                      errors.first(`${item.fieldname}`)
                    }}</span>
                  </p>
                </div>

                <div v-if="item.type === 'color'" class="col-lg-12 col-xl-12">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        v-if="item.type !== 'date'"
                        :disabled="
                          item.fieldname === 'cine_screens' ? isDisabled : false
                        "
                        @focus="onFocusHandler"
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        v-validate="item.validation"
                        v-model="item.fieldvalue"
                        placeholder="."
                      />
                      <input
                        v-if="item.type === 'date'"
                        :disabled="
                          item.fieldname === 'cine_screens'
                            ? isDisabled
                            : item.fieldname === 'org_setup_date'
                            ? true
                            : item.fieldname === 'org_launch_date'
                            ? true
                            : false
                        "
                        @focus="onFocusHandler"
                        :type="item.type"
                        :format="item.format"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        v-validate="item.validation"
                        v-model="item.fieldvalue"
                        placeholder="."
                      />
                      <label>{{ $tc(item.label, 1) }}</label>
                    </div>
                    <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has(item.fieldname)">{{
                      errors.first(`${item.fieldname}`)
                    }}</span>
                  </p>
                </div>

                <div
                  v-if="
                    item.type === 'file' && item.fieldname === 'org_logo_url'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Upload Logo</label
                      >
                      <span class="d-block text-truncate">{{
                        item.fieldvalue
                      }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage(index)"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                        v-b-tooltip.hover.top="
                          'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                        tabIndex="0"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="
                          'Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                        tabIndex="0"
                      />
                    </div>
                    <!-- <Tooltip
                :title="
                  `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                "
              /> -->
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <!-- KIOSK SCREEN IMAGE  -->
                <div
                  v-if="
                    item.type === 'file' &&
                    item.fieldname === 'org_kiosk_screen_image_url'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Upload Kiosk Screen Image</label
                      >
                      <span class="d-block text-truncate">{{
                        item.fieldvalue
                      }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage(index)"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                        v-b-tooltip.hover.top="
                          'Screen Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                        tabIndex="0"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="
                          'Screen Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                      />
                    </div>
                    <!-- <Tooltip
                :title="
                  `Screen Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                "
              /> -->
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <!-- KIOSK SCREEN IMAGE END -->

                <!-- MYCINEMA LOGO  -->
                <div
                  v-if="
                    item.type === 'file' &&
                    item.fieldname === 'org_mycinema_logo'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Upload Mycinema Logo</label
                      >
                      <span class="d-block text-truncate">{{
                        item.fieldvalue
                      }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage(index)"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                        v-b-tooltip.hover.top="{ title: item.tooltip }"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="{ title: item.tooltip }"
                      />
                    </div>
                    <!-- <Tooltip :title="item.tooltip" /> -->
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <!-- MYCINEMA LOGO END  -->

                <!-- DUMMY LOGO  -->
                <div
                  v-if="
                    item.type === 'file' && item.fieldname == 'dummy_poster'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ item.label }}</label
                      >
                      <span class="d-block text-truncate">{{
                        item.fieldvalue
                      }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage(index)"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue"
                        v-b-tooltip.hover.top="{ title: item.tooltip }"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="{ title: item.tooltip }"
                      />
                    </div>
                    <!-- <Tooltip :title="item.tooltip" /> -->
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <!-- DUMMY LOGO END  -->

                <!-- TICKET IMAGE URL  -->
                <div
                  v-if="
                    item.type === 'file' &&
                    item.fieldname === 'ticket_image_url'
                  "
                >
                  <div class="d-flex align-items-center">
                    <label :for="item.fieldname" class="file-selector w-100">
                      <label
                        class="file-selector-label"
                        :class="
                          item.fieldvalue && item.fieldvalue.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Upload Ticket Image</label
                      >
                      <span class="d-block text-truncate">{{
                        item.fieldvalue
                      }}</span>
                      <input
                        :type="item.type"
                        :name="item.fieldname"
                        :id="item.fieldname"
                        placeholder="."
                        class="d-none"
                        v-on:change="setImage($event, index)"
                      />
                    </label>
                    <div class="col-2 align-self-center">
                      <img
                        width="40"
                        height="40"
                        class="rounded"
                        @click="showImage(index)"
                        :src="_GetImagePath(item.fieldvalue)"
                        v-if="item.fieldvalue && item.fieldvalue.length > 0"
                        v-b-tooltip.hover.top="
                          'Ticket Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                        tabIndex="0"
                      />
                      <img
                        v-else
                        width="35"
                        height="35"
                        class="rounded"
                        alt="Empty Image"
                        src="@/assets/img/icons/empty-image.svg"
                        v-b-tooltip.hover.top="
                          'Ticket Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg'
                        "
                        tabIndex="0"
                      />
                    </div>
                    <!-- <Tooltip
                :title="
                  `Ticket Image should be of dimension 1482x258 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                "
              /> -->
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>
                <!-- TICKET IMAGE URLEND -->
                <div v-if="item.type === 'radio'">
                  <!-- <div v-if="item.fieldname === 'org_is_trial'" :class="item.fieldname === 'org_is_trial' ? 'd-none' : ''" class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t('trial') }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>-->
                  <div
                    v-if="item.fieldname === 'org_is_active'"
                    class="d-flex align-items-center"
                  >
                    <label class="mb-0 mr-3">{{ $t("active") }}</label>
                    <!-- <label class="ios-switch"> -->
                    <b-form-checkbox
                      disabled
                      type="checkbox"
                      class="j-checkbox"
                      v-model="item.fieldvalue"
                    />
                    <!-- <span class="switch-slider"></span>
              </label> -->
                  </div>
                </div>

                <div v-if="item.type === 'dropdown'">
                  <div v-if="item.fieldname === 'country_id'">
                    <div class="d-flex align-items-content">
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search Country"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCountry()"
                            v-on:keydown="onSearchCountry()"
                            v-model="searchCountry"
                          />
                        </div>
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in countryList"
                          :key="dropdownIndex"
                          href="#"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          name="select-country"
                          id="select-country"
                          >{{ dropdownItem.country_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >{{ messagecountry }}</span
                      >
                    </p>
                  </div>

                  <div v-if="item.fieldname === 'state_id'">
                    <div class="d-flex align-items-content">
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search State"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchState()"
                            v-on:keydown="onSearchState()"
                            v-model="searchState"
                          />
                        </div>
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in stateList"
                          :key="dropdownIndex"
                          href="#"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          name="select-state"
                          id="select-state"
                          >{{ dropdownItem.state_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >{{ messagestate }}</span
                      >
                    </p>
                  </div>

                  <div v-if="item.fieldname === 'city_id'">
                    <div class="d-flex align-items-center">
                      <b-dropdown
                        :text="item.dropdownSelected"
                        variant="dropdown-curve"
                        class="w-100"
                      >
                        <!-- _getCountryList(item.label, null) -->
                        <div class="px-2 pb-2">
                          <input
                            required
                            autofocus
                            type="search"
                            placeholder="Search City"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCity()"
                            v-on:keydown="onSearchCity()"
                            v-model="searchCity"
                          />
                        </div>
                        <b-dropdown-item
                          v-for="(dropdownItem, dropdownIndex) in cityList"
                          :key="dropdownIndex"
                          href="#"
                          @click="
                            onDropdownChange(
                              $event,
                              item.label,
                              dropdownItem,
                              index
                            )
                          "
                          name="select-city"
                          id="select-city"
                          >{{ dropdownItem.city_name }}</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- <Tooltip :title="$t(item.tooltip)" /> -->
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && item.dropdownSelected.length == 0"
                        >{{ messagecity }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="row container mb-5">
                <!-- show type -->
                <div class="col-md-12 fs-16 pl-4">
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <span class="">Screening Type</span>
                    </div>
                    <div
                      :class="screeningTypeIndex == 0 ? 'col-md-3' : 'col-md-2'"
                      v-for="(
                        screeningType, screeningTypeIndex
                      ) in ShowTypeArray"
                      :key="screeningTypeIndex"
                    >
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="`ogshowtypearr${screeningTypeIndex}`"
                          v-model="screeningType.status"
                        />
                        <label
                          class="form-check-label"
                          :for="`ogshowtypearr${screeningTypeIndex}`"
                        >
                          {{ screeningType.screening_name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <!-- suraj -->
        <section class="mb-5 w-100 px-3 distributor-section-new">
          <div
            class="section-title mb-3 d-flex justify-content-between section-border section-border"
            v-b-toggle.otherTaxesSection
          >
            <span>
              {{ $t("add") }} {{ $tc("distributor", 1) }} {{ $t("taxes") }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="otherTaxesSection"
            class="mt-2"
            v-model="sectionCollapse.defaultTaxesSection"
          >
            <div v-if="defaultTaxes.length > 0">
              <div
                class="row border mx-0 rounded mb-2"
                v-for="(tax, index) in defaultTaxes"
                :key="index"
              >
                <div class="col-11 pl-0 movie-version-box">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="Tax Name"
                              type="text"
                              id="tax_name"
                              name="tax_name"
                              v-model="tax.tax_name"
                              v-validate="'required'"
                            />
                            <label>{{ $t("tax_name") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('tax_name')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && !tax.tax_name">{{
                            $t("tax_name_required")
                          }}</span>
                        </p>
                      </div>
                      <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="Tax Value"
                              type="number"
                              id="tax_value"
                              name="tax_value"
                              v-model="tax.tax_value"
                              v-validate="'required'"
                            />
                            <label>{{ $t("tax_value") }}</label>
                          </div>
                          <!-- <Tooltip :title="$t('tax_value')" /> -->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && !tax.tax_value">{{
                            $t("tax_value_required")
                          }}</span>
                        </p>
                      </div>

                      <div
                        class="col-lg-6 col-xl-4 align-self-center mb-3 pb-4"
                      >
                        <div class="d-flex align-items-center">
                          <label class="mb-0 mr-3">{{
                            $t("isPercentage")
                          }}</label>
                          <!-- <label class="ios-switch"> -->
                          <b-form-checkbox
                            type="checkbox"
                            class="j-checkbox"
                            v-model="tax.is_percentage"
                          />
                          <!-- <span class="switch-slider"></span>
                          </label> -->
                        </div>
                      </div>

                      <div
                        class="col-lg-6 col-xl-4 align-self-center mb-3 pb-4"
                      >
                        <div class="d-flex align-items-center">
                          <label class="mb-0 mr-3">{{
                            $t("is_per_ticket")
                          }}</label>
                          <!-- <label class="ios-switch"> -->
                          <b-form-checkbox
                            type="checkbox"
                            class="j-checkbox"
                            v-model="tax.is_per_ticket"
                          />
                          <!-- <span class="switch-slider"></span>
                          </label> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-1 d-flex align-items-center justify-content-center border-left"
                >
                  <button
                    v-if="index === 0 && false"
                    @click.prevent.stop="addDefaultTaxes($event)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                  <button
                    @click.prevent.stop="removeDefaultTax($event, index)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row w-100 pl-5">
                <p class="mx-auto text-muted">Add Distributor Taxes</p>
              </div>
            </div>
            <div
              class="col-12 d-flex align-items-center justify-content-center border-top mt-5 mb-5 position-relative"
            >
              <button
                @click.prevent.stop="addDefaultTaxes($event)"
                class="btn-transparent add-more-button"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </b-collapse>
        </section>
        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onUpdateHandler" class="btn-blue">
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="organizations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      hide-footer
      ref="preview-modal"
      title="Organization Logo"
      id="selected-image-preview-modal"
      class="preview-img-modal"
    >
      <div class="col-6 mx-auto text-center">
        <img
          :src="_GetImagePath(Organizations[imageIndex].fieldvalue)"
          class="img-fluid"
        />
      </div>
    </b-modal>

    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate float-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
        :autoCropArea="1"
      ></vue-cropper>
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Organizations from "@/helper/formJSONMaster/Organizations";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: { VueCropper },
  data() {
    return {
      cityListCopy: [],
      searchCity: "",
      stateListCopy: [],
      searchState: "",
      countryListCopy: [],
      searchCountry: "",
      Organizations: Organizations.organizations,
      messagecountry: "Please Select Country.",
      messagestate: "Please Select State.",
      messagecity: "Please Select City.",
      Methods: Organizations.Methods,
      submitted: false,
      isDisabled: false,
      selectedCinema: "",
      countryList: [],
      stateList: [],
      cityList: [],
      cine_id: null,
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      imageIndex: 2,
      SelectedCountryCode: "",
      searchCode: "",
      ShowTypeArray: [
        {
          booking_type_id: "4",
          screening_name: "Classic Programming",
          column_name: "is_classic_show",
          status: true,
        },
        {
          booking_type_id: "3",
          screening_name: "Private",
          column_name: "is_private_show",
          status: true,
        },
        {
          booking_type_id: "1",
          screening_name: "Confirmed",
          column_name: "is_confirmed_show",
          status: true,
        },
        {
          booking_type_id: "2",
          screening_name: "Crowd Source",
          column_name: "is_crowd_show",
          status: true,
        },
        {
          booking_type_id: "5",
          screening_name: "Movie Club",
          column_name: "is_movie_club",
          status: true,
        },
      ],
      //Default Distributor Taxes
      defaultTaxes: [],
      sectionCollapse: {
        defaultTaxesSection: false,
        orgainizationDetails: true,
      },
      imageSrc: "@/assets/img/icons/empty-image.svg",
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
      this.isDisabled =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["role_id"] &&
        this.secureStore.get("USINFO")["role_id"] === 1
          ? false
          : true;
      // cine_id = cinema_id;
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getScreenType(columnName) {
      let ShowType = "";
      ShowType = this.ShowTypeArray.find((x) => x.column_name == columnName);
      return ShowType && ShowType.status ? "Y" : "N";
    },
    createShowTypeArray(obj) {
      Object.keys(obj).forEach((x) => {
        this.ShowTypeArray.forEach((y) => {
          if (y["column_name"] == x) {
            y["status"] = obj[x] == "Y" ? true : false;
          }
        });
      });
    },
    addDefaultTaxes() {
      let tax = {
        tax_name: "",
        tax_value: "",
        is_percentage: false,
        is_per_ticket: false,
      };
      this.defaultTaxes.push(tax);
    },
    removeDefaultTax(event, index) {
      this.defaultTaxes.splice(index, 1);
    },
    onSearchCity: function () {
      if (this.searchCity && this.searchCity.length > 0) {
        this.cityList = this.cityListCopy.filter((x) => {
          if (
            x.city_name.toLowerCase().includes(this.searchCity.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cityList = this.cityListCopy;
      }
    },
    onSearchState: function () {
      if (this.searchState && this.searchState.length > 0) {
        this.stateList = this.stateListCopy.filter((x) => {
          if (
            x.state_name.toLowerCase().includes(this.searchState.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.stateList = this.stateListCopy;
      }
    },
    onSearchCountry: function () {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.countryList = this.countryListCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    showImage: function (index) {
      this.imageIndex = index;
      this.$refs["preview-modal"].show();
    },
    onResetForm: function () {
      this.Organizations.map((x) => {
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        }
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    hideCropperModal: function (modal) {
      this.$bvModal.hide("imagecropper");
    },
    setImage: function (e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;
      console.log("e.target", e.target);
      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          if (
            e.target.name === "org_kiosk_screen_image_url" ||
            e.target.name === "org_mycinema_logo"
          ) {
            this.onThumbnailUpload(
              this.file,
              this.filename,
              this.indexofthubmnail
            );
          } else {
            this.$bvModal.show("imagecropper");
          }
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
        // alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      this.$bvModal.hide("imagecropper");
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      console.log(
        "🚀 ~ file: editOrganization.vue ~ line 625 ~ cropImage ~ blob1",
        blob1
      );
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    onThumbnailUpload: function (image, filename, index) {
      let loader = this.$loading.show();
      console.log("image", image);
      let formData = new FormData();
      // formData.append("image", image);
      formData.append("image", image, filename);
      formData.append("imagePath", "Organization Image");
      MasterService.GlobalUploadImage(formData)
        .then((response) => {
          // console.log("response :", response);
          const { data } = response;
          if (data && data.status) {
            this.Organizations[index].fieldvalue = data.path;
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    getEditList: function (id) {
      // let params = `id`
      // this.secureStore.get("USINFO").role_id;
      // console.log(
      //   "this.secureStore.get(editcinme) :",
      //   this.secureStore.get("USINFO").role_id
      // );
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data.status) {
            let obj = data.details[0];
            this.createShowTypeArray(obj);
            let defaultTaxArray = data.details[0].TaxArray;
            if (defaultTaxArray && defaultTaxArray.length > 0) {
              defaultTaxArray.map((x) => {
                let tax = {
                  tax_name: x.tax_name,
                  tax_value: x.tax_value,
                  is_percentage: x.is_percentage == "Y" ? true : false,
                  is_per_ticket: x.is_per_ticket == "Y" ? true : false,
                };
                this.defaultTaxes.push(tax);
              });
            }
            // console.log("obj :", obj);
            this.Organizations.map((x, index) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
                x.dropdownSelected = obj[x.fieldname];
                if (x.fieldname === "country_id") {
                  this.getCountryList(obj[x.fieldname], index);
                }
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            // this.getCountryList(data.details[0].country_id);
            this.getStateList(
              data.details[0].country_id,
              data.details[0].state_id
            );
            this.getCityList(data.details[0].state_id, data.details[0].city_id);
            this.SelectedCountryCode = obj.org_contact_no_code
              ? obj.org_contact_no_code
              : "";
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCityList: function (stateId, cityId) {
      this.cityList = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        params: { id: "state_id-" + stateId },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cityList = data.Records;
            this.cityListCopy = data.Records;
            this.setCityHandler(cityId);
          } else {
            // Show Errors
            console.log("show error :", data.message);
            this.setCityHandler(null);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    setCityHandler: function (cityId) {
      console.log("cityId :>> ", cityId);
      this.Organizations.map((y) => {
        if (y.fieldname === "city_id") {
          if (cityId) {
            this.cityList.map((x) => {
              if (cityId && x.city_id === cityId) {
                y.fieldvalue = x.city_id;
                y.dropdownSelected = x.city_name;
              }
            });
          } else {
            y.dropdownSelected = "Select City";
            y.fieldvalue = null;
          }
        }
      });
    },
    getStateList: function (countryId, stateId) {
      this.stateList = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        params: { id: "country_id-" + countryId },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.stateList = data.Records;
            this.stateListCopy = data.Records;
            this.setStateHandler(stateId);
          } else {
            // Show Errors
            console.log("show error :", data.message);
            this.setStateHandler(null);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    setStateHandler: function (stateId) {
      this.Organizations.map((y) => {
        if (y.fieldname === "state_id") {
          if (stateId) {
            this.stateList.map((x) => {
              if (stateId && x.state_id === stateId) {
                y.fieldvalue = x.state_id;
                y.dropdownSelected = x.state_name;
              }
            });
          } else {
            y.dropdownSelected = "Select State";
            y.fieldvalue = "";
          }
        }
      });
    },
    onSelectHandler(type, value, index) {
      if (type == "countrycode") {
        this.SelectedCountryCode = value.country_mob_code;
      }
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.countryList = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.CodeListCopy;
      }
    },
    getCountryList: function (value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
            this.CodeListCopy = data.Records;
            this.countryList.filter((x) => {
              if (x.country_id === value) {
                this.Organizations[index].fieldvalue = x.country_id;
                this.Organizations[index].dropdownSelected = x.country_name;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      if (type === "country") {
        this.Organizations[mainIndex].fieldvalue = item.country_id;
        this.Organizations[mainIndex].dropdownSelected = item.country_name;
        this.SelectedCountryCode = item.country_mob_code;
        this.getStateList(item.country_id, null);
        this.searchCountry = "";
        this.onSearchCountry();
      } else if (type === "state") {
        this.Organizations[mainIndex].dropdownSelected = item.state_name;
        this.Organizations[mainIndex].fieldvalue = item.state_id;
        console.log("item.state_id :", item.state_id);
        this.getCityList(item.state_id, null);
        this.searchState = "";
        this.onSearchState();
      } else if (type === "city") {
        this.Organizations[mainIndex].dropdownSelected = item.city_name;
        this.Organizations[mainIndex].fieldvalue = item.city_id;
        this.searchCity = "";
        this.onSearchCity();
      }
    },
    onUpdateHandler: function () {
      this.submitted = true;
      if (this.defaultTaxes && this.defaultTaxes.length > 0) {
        this.defaultTaxes.map((x) => {
          if (!x.tax_name) {
            this.$toasted.show("Please Enter Tax Name");
          } else if (!x.tax_value) {
            this.$toasted.show("Please Enter Tax Value");
          }
        });
      }
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        console.log("fsdfdsfsds");
        if (valid) {
          if (!this.SelectedCountryCode) {
            this.$toasted.show("Please select country code");
            return;
          }
          let loader = this.$loading.show();
          console.log("fsdfdsfsds", "sdffsdfsdfsd");
          let body = this.getRequestBody("PUT", this.Organizations, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });
          body.payload.org_contact_no_code = this.SelectedCountryCode
            ? this.SelectedCountryCode
            : "";
          body.payload.is_confirmed_show =
            this.getScreenType("is_confirmed_show");
          body.payload.is_private_show = this.getScreenType("is_private_show");
          body.payload.is_crowd_show = this.getScreenType("is_crowd_show");
          body.payload.is_movie_club = this.getScreenType("is_movie_club");
          body.payload.is_classic_show = this.getScreenType("is_classic_show");
          body.payload.defaultDistributorTaxes = this.defaultTaxes;
          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/master/organizations",
                });
              } else {
                console.log("show error :", data.message);
              }
            })
            .catch((error) => {
              // Catch Error:
              console.log("show error :", error);
              console.log("Catch Error On onUpdateHandler: ", error);
            })
            .finally(() => {
              loader.hide();
            });
        }
      });
    },
  },
};
</script>
<style>
#imagecropper .btn-clearDate {
  margin-top: -10px;
  margin-right: -10px;
  font-size: 19px;
}

#selected-image-preview-modal .modal-header .close {
  top: -6px !important;
  font-size: 35px !important;
  right: -2px !important;
}
.distributor-section-new .input-material input {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/OrganizationComponents/editOrganization.vue